import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import AuthenticationEndpoint from '../../../api/endpoint/AuthenticationEndpoint';

export const AddAdmin = () => {
    const [validated, setValidated] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [user_role] = useState('Admin');
    const [message, setMessage] = useState('');

    const handleSubmit = (event: any) => {
        const form = event.currentTarget;
        const passwordsMatch = password === confirmPassword;

        if (form.checkValidity() === false || !passwordsMatch) {
            event.preventDefault();
            event.stopPropagation();
        } else if(form.checkValidity() === true && passwordsMatch) {
            event.preventDefault();
            handleRegister();
        }

        setValidated(true);
    };

    const handleRegister = async() => {
        try{
            const registration = {
                username: username,
                password: password,
                confirm_password: confirmPassword,
                user_role: user_role
            }

            const registerResult = await AuthenticationEndpoint.Register(registration);

            if(!registerResult || registerResult.errors.length > 0 || !registerResult.data){
                console.error('Error registering user.');
                setMessage('Error adding admin: ' + registerResult.errors);
            }
            else {
                setMessage('Successful add admin!');
            }
        } catch(err) {
            console.error('Error registering user.');
            setMessage('Error adding admin: ' + (err instanceof Error ? err.message : String(err)));
        }
        
    }

    return (
        <Card style={{margin:'10% 25%'}}>
            <Card.Body>
                <Card.Title>Add Admin</Card.Title>
                <Card.Text>
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Username</Form.Label>
                            <Form.Control required value={username} onChange={(e) => setUsername(e.target.value)} type="text"/>
                            <Form.Control.Feedback type="invalid">Please enter a username.</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control required value={password} onChange={(e) => setPassword(e.target.value)} type="password"/>
                                <Form.Control.Feedback type="invalid">Please enter a password.</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Confirm Password</Form.Label>
                            <Form.Control 
                                required 
                                value={confirmPassword} 
                                onChange={(e) => setConfirmPassword(e.target.value)} 
                                type="password"
                                isInvalid={validated && password !== confirmPassword}    
                            />
                            <Form.Control.Feedback type="invalid">Passwords must match.</Form.Control.Feedback>
                        </Form.Group>

                        <div className="d-flex gap-3 align-items-center">
                            <Button type="submit" className="text-light">Add</Button>
                            <div className={message.includes('Success') ? 'text-success' : 'text-danger'}>
                                {message}
                            </div>
                        </div>
                        
                    </Form>
                </Card.Text>
                
            </Card.Body>
            
        </Card>
    )
}